import React, { useEffect, useState } from "react";
import { Button, Container, Grid, Icon, Image } from "semantic-ui-react";
import buildUrl from "build-url";
import moment from "moment";
import axios from "axios";
import _ from "lodash";
import cx from "classnames";

import styles from "./profile.module.scss";
import { useSelector } from "react-redux";
import { isAccountSuspended } from "components/features/Util/Util";

import activeStatus from "../../../../../../images/active.svg";

const initProfile = {
  enabled: false,
  thumbnail: "https://react.semantic-ui.com/images/avatar/large/steve.jpg",
  lastActivity: null,
  cleverstory: false,
};

export default function Profile({ user, permissionData }) {
  const [profile, setProfile] = useState(initProfile);

  const account = useSelector((state) => state.accounts.account);

  useEffect(() => {
    if (user) {
      setProfile({
        enabled: user.enabled,
        lastActivity: user.lastActivityDate,
        thumbnail: user.icon ? user.icon.thumbnail : profile.thumbnail,
        cleverstory: user.cleverstory,
      });
    }
  }, [user]);

  const signInAsUser = () => {
    let url = buildUrl(process.env.REACT_APP_API_URL + "/api/1.0/users", {
      path: `${user.id}/sign-in`,
    });

    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          let signInUrl = response.data;
          window.open(signInUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log("sign in as error: ", error);
      });
  };

  const signInAsUserCleverstory = () => {
    let url = buildUrl(process.env.REACT_APP_API_URL + "/api/1.0/users", {
      path: `${user.id}/sign-in/cleverstory-v2`,
    });

    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          let signInUrl = response.data;
          window.open(signInUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log("sign in as error: ", error);
      });
  };


  return (
    <>
      <Container className={cx(styles.profile)}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={11}>
              <div className={cx(styles.image)}>
                <Image src={profile.thumbnail} className={cx(styles.src)} />
                <img
                  src={activeStatus}
                  className={cx(styles.icon, styles.active)}
                />
              </div>
              <div className={cx(styles.detail)}>
                <Grid>
                  <Grid.Row className={cx(styles.p0)}>
                    <Grid.Column>
                      <div className={cx(styles.name)}>{user && user.name}</div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row className={cx(styles.p0)}>
                    <Grid.Column>
                      <div className={cx(styles.lastActivity)}>
                        {profile.lastActivity &&
                          moment(profile.lastActivity).fromNow()}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Grid.Column>
            <Grid.Column width={5} className={cx(styles.signInAs, styles.p0)}>
              <Grid>
                <Grid.Row className={cx(styles.p0)}>
                  <Grid.Column>
                    <Button
                      onClick={signInAsUser}
                      className={cx(styles.text)}
                      content={"SIGN IN PAPERFLITE"}
                      disabled={
                        isAccountSuspended(account) ||
                        !_.get(permissionData, 'user.write', false) ||
                        !_.get(user, 'enabled', true)
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
                {profile.cleverstory && (
                  <Grid.Row className={cx(styles.p0)}>
                    <Grid.Column>
                      <Button
                        onClick={signInAsUserCleverstory}
                        className={cx(styles.text)}
                        content={"SIGN IN CLEVERSTORY"}
                        disabled={
                          isAccountSuspended(account) ||
                          !_.get(permissionData, 'user.write', true) ||
                          !_.get(user, 'enabled', true)
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                )}
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center"></Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column></Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </>
  );
}
